import { RefObject } from 'react';
import { ChipsRemoveEvent } from 'primereact/chips';

// Resolves which chip Prime removed: the clicked token's DOM position, or the last chip for the Backspace-on-empty-input path whose event target is the input, not a token.
export const getRemovedChipIndex = (
  event: ChipsRemoveEvent,
  containerRef: RefObject<HTMLDivElement | null>,
  chipsCount: number
): number => {
  const target = event.originalEvent?.target;
  if (target instanceof Element && containerRef.current) {
    const token = target.closest('.p-chips-token');
    if (token) {
      const tokens = Array.from(
        containerRef.current.querySelectorAll('.p-chips-token')
      );
      const index = tokens.indexOf(token);
      if (index !== -1) return index;
    }
  }
  return chipsCount - 1;
};
